import { FC, useEffect } from 'react'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useEmployeeAndTagsWithRankingDisabled } from '../../../graphql/talents-season/useEmployeesAndTagsWIthRankingDisabled'
import { useTalentsSeasonSettings } from '../../../graphql/talents-season/useTalentsSeasonData'
import { Country, TalentsSeasonSettingsDto } from '../../../types'
import { useCultivatingTalentsStore } from '../../cultivatingTalents/CultivatingTalentsStore'
import { TagAssignmentTable } from '../../cultivatingTalents/TagAssignmentTable'
import { RankingDisabledInfoBox } from './RankingDisabledInfoBox'
import { RankingToggle } from './RankingToggle'

interface CultivatingTalentsWithTagAssignmentProps {
  country: Country
  companyId: string
  isHRSettings: boolean
  isAllCompaniesSettings: boolean
  isYourCompanyView: boolean
}

export const CultivatingTalentsWithTagAssignment: FC<CultivatingTalentsWithTagAssignmentProps> = ({
  isHRSettings,
  companyId,
  country,
  isAllCompaniesSettings,
  isYourCompanyView,
}) => {
  const [getTalentsSeasonSettings, { data: settingsData, loading: settingsLoading, error: settingsError }] = useTalentsSeasonSettings()
  const settings: TalentsSeasonSettingsDto | undefined =
    settingsData && settingsData.talentsSeasonSettings ? settingsData.talentsSeasonSettings : undefined
  const { data, error, loading } = useEmployeeAndTagsWithRankingDisabled(companyId, country)
  const [setTalentsSeasonSettings, setEmployeesWithoutRank, talentsSeasonSettings] = useCultivatingTalentsStore((state) => [
    state.setTalentsSeasonSettings,
    state.setEmployeesWithoutRank,
    state.talentsSeasonSettings,
  ])

  useEffect(() => {
    getTalentsSeasonSettings({ variables: { companyId, country, year: 0 } })
  }, [getTalentsSeasonSettings, companyId, country])

  useEffect(() => {
    if (settings) {
      setTalentsSeasonSettings(settings)
    }
    if (data) {
      setEmployeesWithoutRank(data.employeesAndTagsWithRankingDisabled)
    }
  }, [setTalentsSeasonSettings, settings, data, setEmployeesWithoutRank])

  if (
    loading ||
    settingsLoading ||
    error ||
    settingsError ||
    !data ||
    !data.employeesAndTagsWithRankingDisabled ||
    !settings ||
    !talentsSeasonSettings
  ) {
    return (
      <LoadingAndErrors
        isLoading={loading || settingsLoading}
        hasNoData={!data || !data.employeesAndTagsWithRankingDisabled}
        error={error || settingsError}
        showSpinner
      />
    )
  }

  const employeesData = data.employeesAndTagsWithRankingDisabled
  return (
    <>
      {isHRSettings && <RankingToggle isRankingEnabled={false} companyId={companyId} country={country} />}
      <RankingDisabledInfoBox employeesData={employeesData} />
      <TagAssignmentTable
        tableData={employeesData}
        companyId={companyId}
        country={country}
        isHRSettings={isHRSettings}
        isAllCompaniesSettings={isAllCompaniesSettings}
        isYourCompanyView={isYourCompanyView}
      />
    </>
  )
}
